import prefixCharacterAddition from "./prefixCharacterAddition";

const dateConverterUSA = (value: string): string => {
	const parsedDate = Date.parse(value);
	const date = new Date(parsedDate);
	const convertedDate = date.getMonth() + "-" + date.getDate() + "-" + date.getFullYear();
	return convertedDate;
};

export default dateConverterUSA;

export const getCurrentDate = (): string =>
	new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate();

export const manualDateComparator = (_date1: string, _date2: string): number => {
	const date1 = new Date(_date1);
	const date2 = new Date(_date2);

	const firstDate = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate();
	const secondDate = date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate();

	if (new Date(firstDate).getTime() > new Date(secondDate).getTime()) return 1;
	else if (new Date(firstDate).getTime() < new Date(secondDate).getTime()) return -1;
	else return 0;
};

export const mongoDBDateParserToUSAFormat = (date: string): string => {
	const splitDate = date.split("-");
	const year = splitDate[0];
	let month = splitDate[1];
	let day = splitDate[2].split("T")[0];

	if (Number(month) < 10 && !month.startsWith("0")) month = "0" + month;

	if (Number(day) < 10 && !day.startsWith("0")) day = "0" + day;

	const revisedDate = month + "-" + day + "-" + year;
	return revisedDate;
};

// Currently Used Date Function - Start
export const dateTimeZoneConverter = (_date: string): Date | string => {
	let timeZoneFormattedDate: Date;
	const date = new Date(_date);

	const userTimeZoneOffset = date.getTimezoneOffset() * 60000; // Converting the TimezoneOffset() to milliseconds

	if (userTimeZoneOffset >= 0) timeZoneFormattedDate = new Date(date.getTime() + userTimeZoneOffset);
	else timeZoneFormattedDate = new Date(date.getTime() - userTimeZoneOffset);

	return UIFormattedDate(timeZoneFormattedDate);
};

export const UIFormattedDate = (date: Date): string => {
	const formattedDate =
		prefixCharacterAddition(date.getMonth() + 1) +
		"-" +
		prefixCharacterAddition(date.getDate()) +
		"-" +
		date.getFullYear();

	return formattedDate;
};

export const dateTimeZoneDOBConverter = (_date: string): Date | string => {
	let timeZoneFormattedDate: Date;
	const date = new Date(_date);

	const userTimeZoneOffset = date.getTimezoneOffset() * 60000; // Converting the TimezoneOffset() to milliseconds

	if (userTimeZoneOffset >= 0) timeZoneFormattedDate = new Date(date.getTime() + userTimeZoneOffset);
	else timeZoneFormattedDate = new Date(date.getTime() - userTimeZoneOffset);

	return UIFormattedDOBDate(timeZoneFormattedDate);
};

export const UIFormattedDOBDate = (date: Date): string => {
	const formattedDate =
		prefixCharacterAddition(date.getMonth() + 1) +
		"/" +
		prefixCharacterAddition(date.getDate()) +
		"/" +
		date.getFullYear();

	return formattedDate;
};

export const dateTimeZoneConverterForDialog = (_date: string): Date | string => {
	let timeZoneFormattedDate: Date;
	const date = new Date(_date);

	const userTimeZoneOffset = date.getTimezoneOffset() * 60000; // Converting the TimezoneOffset() to milliseconds

	if (userTimeZoneOffset >= 0) timeZoneFormattedDate = new Date(date.getTime() + userTimeZoneOffset);
	else timeZoneFormattedDate = new Date(date.getTime() - userTimeZoneOffset);

	return UIFormattedDateForDialog(timeZoneFormattedDate);
};

export const UIFormattedDateForDialog = (date: Date): string => {
	const formattedDate =
		date.getFullYear() +
		"-" +
		prefixCharacterAddition(date.getMonth() + 1) +
		"-" +
		prefixCharacterAddition(date.getDate());

	return formattedDate;
};
// Currently Used Date Function - End

export const getFirstOfNextMonth = (): string => {
	const newDate = new Date();
	newDate.setMonth(newDate.getMonth() + 1);
	// console.log("newdate 1", newDate);
	const formattedDate = newDate.getFullYear() + "-" + (newDate.getMonth() + 1) + "-" + 1;
	// console.log("newdate 2", formattedDate);
	return formattedDate;
};

export const dateConverterToUSFormat = (_date: string): string => {
	const parsedDate: number = Date.parse(_date);
	const date: Date = new Date(parsedDate);

	const formattedDate =
		prefixCharacterAddition(date.getMonth() + 1) +
		"-" +
		prefixCharacterAddition(date.getDate()) +
		"-" +
		date.getFullYear();

	return formattedDate;
};

export const mongoDBDateParserToUSAFormat_v2 = (date: string): string => {
	const splitDate = date.split("-");
	const year = splitDate[0];
	let month = splitDate[1];
	let day = splitDate[2].split("T")[0];

	if (Number(month) < 10 && !month.startsWith("0")) month = "0" + month;

	if (Number(day) < 10 && !day.startsWith("0")) day = "0" + day;

	const revisedDate = month + "-" + day + "-" + year;
	return revisedDate;
	// return UIFormattedDOBDate(new Date(revisedDate));
};

export const mongoDBDateParserToUSAFormatV2 = (date: string): string => {
	const splitDate = date.split("-");
	const year = splitDate[0];
	let month = splitDate[1];
	let day = splitDate[2].split("T")[0];

	if (Number(month) < 10 && !month.startsWith("0")) month = "0" + month;

	if (Number(day) < 10 && !day.startsWith("0")) day = "0" + day;

	const revisedDate = year + "-" + month + "-" + day;
	return revisedDate;
};

export const monthDayFormatterForWLTQuery = (date: string): string => {
	const parsedDate = mongoDBDateParserToUSAFormatV2(date);
	const formattedDate = new Date(parsedDate);
	let year = formattedDate.getFullYear();
	let month = formattedDate.getMonth() + 1;
	let day = formattedDate.getDate();

	// alert(`Month: ${parsedDate}`);

	const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	if (timeZone.includes("America")) {
		formattedDate.setDate(formattedDate.getDate() + 1);
		year = formattedDate.getFullYear();
		month = formattedDate.getMonth() + 1;
		day = formattedDate.getDate();
		// if (Number(month) > 10 && Number(day) > 10) {
		// 	formattedDate.setDate(formattedDate.getDate() + 1);
		// 	year = formattedDate.getFullYear();
		// 	month = formattedDate.getMonth() + 1;
		// 	day = formattedDate.getDate();
		// }
	}

	const revisedDate = month + "-" + day + "-" + year;
	return revisedDate;
};
